import { Component, OnInit, Input } from '@angular/core';
import { I18ConfigService } from 'src/app/services/shared/I18-config.service';

@Component({
  selector: 'app-order-details',
  templateUrl: './order-details.component.html',
  styleUrls: ['./order-details.component.scss'],
})
export class OrderDetailsComponent implements OnInit {
  @Input() orderDetails: any;
  @Input() discountConfig: any;
  @Input() campaignInfo: any;
  @Input() paymentInfo?: any;
  @Input() salesSummary: any;

  public totalPrice: any = 0;
  public finalPrice: any = 0;
  public currencyCode: any;

  constructor(i18ConfigService: I18ConfigService) {
    this.currencyCode = i18ConfigService.getCurrency();
  }

  ngOnInit() {
    this.orderDetails.forEach((element: any) => {
      this.currencyCode = element?.metaInfo?.currency;
      let itemTotalPrice = 0;
      itemTotalPrice =
        element?.metaInfo.finalPrice * element?.metaInfo.quantity;
      this.totalPrice = this.totalPrice + itemTotalPrice;
    });
    this.salesSummary = this.getSalesSummery();
    this.finalPrice = this.totalPrice;
    if (this.campaignInfo && this.campaignInfo?.campaignDiscount) {
      this.finalPrice = this.finalPrice - this.campaignInfo?.campaignDiscount;
    }
  }

  getSalesSummery() {
    return this.salesSummary ? Object.entries(this.salesSummary) : null;
  }
}
